import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { DocumentDto } from "../../types/document";

interface DocumentsState {
  documents: DocumentDto[];
  isLoading: boolean;
}
const initialState: DocumentsState = {
  documents: [],
  isLoading: false,
};

export const documentsState = createSlice({
  name: "documents",
  initialState,
  reducers: {
    setDocuments: (state, action: PayloadAction<DocumentDto[]>) => {
      state.documents = action.payload;
    },
    setIsLoading: (state, action: PayloadAction<boolean>) => {
      state.isLoading = action.payload;
    },
  },
});

export const { setIsLoading, setDocuments } = documentsState.actions;
export default documentsState.reducer;
